import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3f874b39"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = { class: "alert alert-dismissible alert-success" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }),
  /*#__PURE__*/_createTextVNode(" Reporte Actualizada Exitosamente! ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-file-alt",
    _mstvisible: "2"
  }),
  /*#__PURE__*/_createTextVNode(" Detalle de Asignación ")
], -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "description"
}, "Descripción:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "description"
}, "Detalles:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "type"
}, "Tipo:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Soporte", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Empleado", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Asistencia", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "type"
}, "Status:", -1))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<option data-v-3f874b39>Reportado</option><option data-v-3f874b39>Recibido</option><option data-v-3f874b39>Evaluado</option><option data-v-3f874b39>Priorizado</option><option data-v-3f874b39>Inicializado</option><option data-v-3f874b39>Detenido</option><option data-v-3f874b39>Concluído</option><option data-v-3f874b39>Entregado</option><option data-v-3f874b39>Seguido</option><option data-v-3f874b39>Validado</option>", 10)
const _hoisted_29 = [
  _hoisted_19
]
const _hoisted_30 = { class: "grid" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAlert())),
          type: "button",
          class: "btn-close",
          "data-bs-dismiss": "alert"
        }),
        _hoisted_6
      ], 512), [
        [_vShow, _ctx.showAlert]
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "description",
                  type: "description",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.reporte.description) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, this.reporte.description]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "description",
                  type: "description",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.reporte.detalles) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, this.reporte.detalles]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "type",
                  type: "type",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reporte.type) = $event)),
                  class: "form-select"
                }, _hoisted_17, 512), [
                  [_vModelSelect, _ctx.reporte.type]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _withDirectives(_createElementVNode("select", {
                  id: "type",
                  type: "type",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reporte.status) = $event)),
                  class: "form-select"
                }, _hoisted_29, 512), [
                  [_vModelSelect, _ctx.reporte.status]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              class: "btn btn-success btn-sm",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
              disabled: !_ctx.reporte.description || !_ctx.reporte.type
            }, _hoisted_34, 8, _hoisted_31)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}